/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator(), model);
        AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.newInstance(<AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Exploitability metric(s) attack vector v3.1 to include
     */
    attack_vector_v31: Array<models.CvssV31ExploitabilityAttackVector>;

}
